export default "__VITE_ASSET__BNaBz26U__"